import { FC } from 'react';

import { useMediaQuery } from '@mui/material';

import SectionLeadLeftAlign from '@components_iqfu/public/section_lead_left_align/SectionLeadLeftAlign';

import { MediaQuery } from '@constants_common';
import { CompaniesPageCategory } from '@constants_iqfu';

import ColumnData from './ranking_short_column_data.json';
import styles from './RankingShortColumn.module.scss';

type Props = {
  type: keyof typeof CompaniesPageCategory;
};

const RankingShortColumn: FC<Props> = ({ type }) => {
  const isMobile = useMediaQuery(MediaQuery.lg);

  return (
    <>
      {ColumnData[type]?.title && (
        <div className={styles.container}>
          <div className={styles.section_lead}>
            <SectionLeadLeftAlign>{ColumnData[type].title}</SectionLeadLeftAlign>
          </div>
          <div className={styles.column_wrapper}>
            {!isMobile && <img src="/images/iqfu/public/ranking_short_column_icon.png" alt="イク子画像" />}
            {/* <p>{ColumnData[type].body}</p> */}
            {<div dangerouslySetInnerHTML={{ __html: ColumnData[type].body }}></div>}
          </div>
        </div>
      )}
    </>
  );
};

export default RankingShortColumn;
